var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutoRenewalEnabled = function SvgAutoRenewalEnabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8Zm0 14.99A6.994 6.994 0 0 1 3.01 10 6.994 6.994 0 0 1 10 3.01 6.994 6.994 0 0 1 16.99 10 6.994 6.994 0 0 1 10 16.99Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.544 5.772a.488.488 0 0 0-.708 0 .488.488 0 0 0 0 .708l.438.438h-5.76a.496.496 0 0 0-.505.505v2.24c0 .286.219.505.505.505.286 0 .505-.219.505-.505V7.928h5.255l-.438.438a.488.488 0 0 0 0 .708.487.487 0 0 0 .708 0l1.296-1.297a.489.489 0 0 0 0-.707l-1.296-1.298ZM13.486 9.832a.496.496 0 0 0-.505.505v1.735H7.726l.439-.438a.488.488 0 0 0 0-.708.488.488 0 0 0-.708 0l-1.296 1.297a.488.488 0 0 0 0 .707l1.296 1.297a.487.487 0 0 0 .708 0 .488.488 0 0 0 0-.707l-.438-.438h5.76c.286 0 .505-.22.505-.506v-2.24a.507.507 0 0 0-.506-.504Z",
    fill: "#666"
  })));
};
export default SvgAutoRenewalEnabled;